(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/assets/javascripts/widget-area.js') >= 0) return;  svs.modules.push('/components/core/widget-area/assets/javascripts/widget-area.js'); "use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var svs = svs || {}; 

(function (svs, $) {
  'use strict';

  svs.core = svs.core || {};
  svs.widget = svs.widget || {};
  svs.core.widget_area = svs.core.widget_area || {};
  svs.core.widget_area.logger = new svs.core.log.Logger('core:widget-area'); 

  var widgetFiltering = {};

  function initWidget(area, index, widget, widgetData) {
    var $el, data, $area; 

    if (!area) {
      svs.core.widget_area.logger.warn('No area supplied');
      return;
    }

    if (!widget) {
      svs.core.widget_area.logger.warn('No widget supplied');
      return;
    } 


    $el = $("#".concat(area, " > .widget"));

    if (!widget.templates) {
      widget.init(widgetData);
    } else if (Boolean($el.get(index)) && $($el.get(index)).children().length > 0) {
      data = {};
      data.$el = $($el.get(index)).children();
      data.model = widgetData;
      widget.init(data);
    } else {
      try {
        $area = $("#".concat(area));

        if ($area.length > 0) {
          $area.on('widgetAttached', function () {
            data = {};
            $el = $("#".concat(area, " .widget"));
            data.$el = $($el.get(index)).children();
            data.model = widgetData;
            widget.init(data);
          });
        }
      } catch (e) {
        svs.core.widget_area.logger.error("Error initializing widget: ".concat(e.message), area);
      }
    }
  }


  function findWidget(obj, area) {
    Object.keys(obj).forEach(function (key) {
      if (!area || area === key) {
        if (typeof obj[key].forEach === 'function') {
          var widgets = obj[key];
          widgets.forEach(function (widget, index) {
            if (widget.widget) {
              if (svs.widget[widget.widget]) {
                if (typeof svs.widget[widget.widget].init === 'function') {
                  initWidget(key, index, svs.widget[widget.widget], widget.data);
                } else {
                  if (widgetFiltering[widget.widget]) {
                    widgetFiltering[widget.widget] = true;
                    svs.core.widget_area.logger.debug("No init function found for widget: ".concat(widget.widget));
                  }
                }
              }
            }
          });
        } else if (_typeof(obj[key]) === 'object') {
          svs.core.widget_area.logger.info('Widget of object type used.');
          findWidget(obj[key], area);
        }
      }
    });
  }


  function init(area) {
    if (svs.widgets && svs.widgets.data) {
      findWidget(svs.widgets.data, area);
    }
  }


  function loadArea(area, className, finalCallback) {
    if (finalCallback === undefined) {
      finalCallback = className;
      className = undefined;
    }

    var widgets = svs.widgets.data[area];

    if (widgets) {
      var widgetsToLoad = widgets 
      .filter(function (widget) {
        return widget.data && widget.data.fetchDataUrl;
      }) 
      .map(function (widget) {
        var d = $.Deferred(),
            widgetName = widget.widget,
            widgetComponent = svs.widget[widgetName];

        if (widgetComponent && widgetComponent.fetchData) {
          var _widget$data = widget.data,
              url = _widget$data.fetchDataUrl,
              data = _objectWithoutProperties(_widget$data, ["fetchDataUrl"]);

          widgetComponent.fetchData({
            area: area,
            url: url
          }, data, function (err, completeData) {
            if (completeData) {
              widget.data = completeData;
              widget.partial = "widget-".concat(widgetName, "-").concat(Object.keys(widgetComponent.templates)[0]);
            }

            d.resolve();
          });
        } else {
          d.resolve();
        }

        return d;
      }); 

      $.when.apply(this, widgetsToLoad).then(function () {
        var templateString = Handlebars.helpers.widgetArea({
          hash: {
            name: area,
            class: className
          }
        });
        finalCallback(templateString);
      }, function () {
        finalCallback(); 
      });
    } else {
      finalCallback();
    }
  } 


  svs.core.widget_area.init = init;
  svs.core.widget_area.loadArea = loadArea; 

  $(function () {
    return init();
  });
})(svs, $);
 })(window);